/**
 * Generated by orval v7.9.0 🍺
 * Do not edit manually.
 * OSI.Core
 * OpenAPI spec version: v1
 */
import { useMutation, useQuery } from '@tanstack/react-query';
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseQueryResult,
  MutationFunction,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult
} from '@tanstack/react-query';

import type {
  ApiResponse,
  ApiResponseIEnumerable1OSICoreModelsReportsSaldoOnAllPeriodSaldoPeriodPrivateCoreLib,
  ApiResponseInt32SystemPrivateCoreLib,
  ApiResponseList1OSICoreModelsReportsAccuralsByAbonentAndServicesGroupPrivateCoreLib,
  ApiResponseList1OSICoreModelsReportsFixTransactionPrivateCoreLib,
  ApiResponseList1OSICoreModelsReportsPaymentTransactionPrivateCoreLib,
  ApiResponseReportsOSVAbonentOSICoreTypes,
  ApiResponseReportsOSVOSICoreTypes,
  ApiResponseResponsesCreatePaymentResponseOSICoreTypes,
  ApiResponseResponsesEndSaldoResponseOSICoreTypes,
  GetApiTransactionsAccuralsByAbonentAndServicesAbonentIdParams,
  GetApiTransactionsFixesOsiIdParams,
  GetApiTransactionsOsvForDebtorsOsiIdParams,
  GetApiTransactionsOsvOsiIdParams,
  GetApiTransactionsPaymentsOsiIdParams,
  GetApiTransactionsSaldoOnPeriodAbonentIdParams,
  PostApiTransactionsFineParams,
  PostApiTransactionsFixInternalParams,
  PostApiTransactionsPaymentInternalParams,
  PostApiTransactionsPaymentParams,
  RequestsCreateFixRequest,
  RequestsCreatePaymentInternalRequest,
  RequestsCreatePaymentRequest
} from '../models';

import { axiosForReactQueryInstance } from '../../reactQuery';
import type { ErrorType, BodyType } from '../../reactQuery';

type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];

/**
 * @summary Получить сальдо по абоненту
 */
export const getApiTransactionsSaldoAbonentId = (
  abonentId: number,
  options?: SecondParameter<typeof axiosForReactQueryInstance>,
  signal?: AbortSignal
) => {
  return axiosForReactQueryInstance<ApiResponseResponsesEndSaldoResponseOSICoreTypes>(
    { url: `/api/Transactions/saldo/${abonentId}`, method: 'GET', signal },
    options
  );
};

export const getGetApiTransactionsSaldoAbonentIdQueryKey = (abonentId: number) => {
  return [`/api/Transactions/saldo/${abonentId}`] as const;
};

export const getGetApiTransactionsSaldoAbonentIdQueryOptions = <
  TData = Awaited<ReturnType<typeof getApiTransactionsSaldoAbonentId>>,
  TError = ErrorType<unknown>
>(
  abonentId: number,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiTransactionsSaldoAbonentId>>, TError, TData>>;
    request?: SecondParameter<typeof axiosForReactQueryInstance>;
  }
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetApiTransactionsSaldoAbonentIdQueryKey(abonentId);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getApiTransactionsSaldoAbonentId>>> = ({ signal }) =>
    getApiTransactionsSaldoAbonentId(abonentId, requestOptions, signal);

  return { queryKey, queryFn, enabled: !!abonentId, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getApiTransactionsSaldoAbonentId>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetApiTransactionsSaldoAbonentIdQueryResult = NonNullable<
  Awaited<ReturnType<typeof getApiTransactionsSaldoAbonentId>>
>;
export type GetApiTransactionsSaldoAbonentIdQueryError = ErrorType<unknown>;

export function useGetApiTransactionsSaldoAbonentId<
  TData = Awaited<ReturnType<typeof getApiTransactionsSaldoAbonentId>>,
  TError = ErrorType<unknown>
>(
  abonentId: number,
  options: {
    query: Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiTransactionsSaldoAbonentId>>, TError, TData>> &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiTransactionsSaldoAbonentId>>,
          TError,
          Awaited<ReturnType<typeof getApiTransactionsSaldoAbonentId>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof axiosForReactQueryInstance>;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetApiTransactionsSaldoAbonentId<
  TData = Awaited<ReturnType<typeof getApiTransactionsSaldoAbonentId>>,
  TError = ErrorType<unknown>
>(
  abonentId: number,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiTransactionsSaldoAbonentId>>, TError, TData>> &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiTransactionsSaldoAbonentId>>,
          TError,
          Awaited<ReturnType<typeof getApiTransactionsSaldoAbonentId>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof axiosForReactQueryInstance>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetApiTransactionsSaldoAbonentId<
  TData = Awaited<ReturnType<typeof getApiTransactionsSaldoAbonentId>>,
  TError = ErrorType<unknown>
>(
  abonentId: number,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiTransactionsSaldoAbonentId>>, TError, TData>>;
    request?: SecondParameter<typeof axiosForReactQueryInstance>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary Получить сальдо по абоненту
 */

export function useGetApiTransactionsSaldoAbonentId<
  TData = Awaited<ReturnType<typeof getApiTransactionsSaldoAbonentId>>,
  TError = ErrorType<unknown>
>(
  abonentId: number,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiTransactionsSaldoAbonentId>>, TError, TData>>;
    request?: SecondParameter<typeof axiosForReactQueryInstance>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetApiTransactionsSaldoAbonentIdQueryOptions(abonentId, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * @summary Получить сальдо по абоненту за период
 */
export const getApiTransactionsSaldoOnPeriodAbonentId = (
  abonentId: number,
  params: GetApiTransactionsSaldoOnPeriodAbonentIdParams,
  options?: SecondParameter<typeof axiosForReactQueryInstance>,
  signal?: AbortSignal
) => {
  return axiosForReactQueryInstance<ApiResponseReportsOSVAbonentOSICoreTypes>(
    { url: `/api/Transactions/saldo-on-period/${abonentId}`, method: 'GET', params, signal },
    options
  );
};

export const getGetApiTransactionsSaldoOnPeriodAbonentIdQueryKey = (
  abonentId: number,
  params: GetApiTransactionsSaldoOnPeriodAbonentIdParams
) => {
  return [`/api/Transactions/saldo-on-period/${abonentId}`, ...(params ? [params] : [])] as const;
};

export const getGetApiTransactionsSaldoOnPeriodAbonentIdQueryOptions = <
  TData = Awaited<ReturnType<typeof getApiTransactionsSaldoOnPeriodAbonentId>>,
  TError = ErrorType<unknown>
>(
  abonentId: number,
  params: GetApiTransactionsSaldoOnPeriodAbonentIdParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getApiTransactionsSaldoOnPeriodAbonentId>>, TError, TData>
    >;
    request?: SecondParameter<typeof axiosForReactQueryInstance>;
  }
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetApiTransactionsSaldoOnPeriodAbonentIdQueryKey(abonentId, params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getApiTransactionsSaldoOnPeriodAbonentId>>> = ({ signal }) =>
    getApiTransactionsSaldoOnPeriodAbonentId(abonentId, params, requestOptions, signal);

  return { queryKey, queryFn, enabled: !!abonentId, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getApiTransactionsSaldoOnPeriodAbonentId>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetApiTransactionsSaldoOnPeriodAbonentIdQueryResult = NonNullable<
  Awaited<ReturnType<typeof getApiTransactionsSaldoOnPeriodAbonentId>>
>;
export type GetApiTransactionsSaldoOnPeriodAbonentIdQueryError = ErrorType<unknown>;

export function useGetApiTransactionsSaldoOnPeriodAbonentId<
  TData = Awaited<ReturnType<typeof getApiTransactionsSaldoOnPeriodAbonentId>>,
  TError = ErrorType<unknown>
>(
  abonentId: number,
  params: GetApiTransactionsSaldoOnPeriodAbonentIdParams,
  options: {
    query: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getApiTransactionsSaldoOnPeriodAbonentId>>, TError, TData>
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiTransactionsSaldoOnPeriodAbonentId>>,
          TError,
          Awaited<ReturnType<typeof getApiTransactionsSaldoOnPeriodAbonentId>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof axiosForReactQueryInstance>;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetApiTransactionsSaldoOnPeriodAbonentId<
  TData = Awaited<ReturnType<typeof getApiTransactionsSaldoOnPeriodAbonentId>>,
  TError = ErrorType<unknown>
>(
  abonentId: number,
  params: GetApiTransactionsSaldoOnPeriodAbonentIdParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getApiTransactionsSaldoOnPeriodAbonentId>>, TError, TData>
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiTransactionsSaldoOnPeriodAbonentId>>,
          TError,
          Awaited<ReturnType<typeof getApiTransactionsSaldoOnPeriodAbonentId>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof axiosForReactQueryInstance>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetApiTransactionsSaldoOnPeriodAbonentId<
  TData = Awaited<ReturnType<typeof getApiTransactionsSaldoOnPeriodAbonentId>>,
  TError = ErrorType<unknown>
>(
  abonentId: number,
  params: GetApiTransactionsSaldoOnPeriodAbonentIdParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getApiTransactionsSaldoOnPeriodAbonentId>>, TError, TData>
    >;
    request?: SecondParameter<typeof axiosForReactQueryInstance>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary Получить сальдо по абоненту за период
 */

export function useGetApiTransactionsSaldoOnPeriodAbonentId<
  TData = Awaited<ReturnType<typeof getApiTransactionsSaldoOnPeriodAbonentId>>,
  TError = ErrorType<unknown>
>(
  abonentId: number,
  params: GetApiTransactionsSaldoOnPeriodAbonentIdParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getApiTransactionsSaldoOnPeriodAbonentId>>, TError, TData>
    >;
    request?: SecondParameter<typeof axiosForReactQueryInstance>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetApiTransactionsSaldoOnPeriodAbonentIdQueryOptions(abonentId, params, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * @summary Получить сальдо по абоненту за все периоды
 */
export const getApiTransactionsSaldoOnAllPeriodsAbonentId = (
  abonentId: number,
  options?: SecondParameter<typeof axiosForReactQueryInstance>,
  signal?: AbortSignal
) => {
  return axiosForReactQueryInstance<ApiResponseIEnumerable1OSICoreModelsReportsSaldoOnAllPeriodSaldoPeriodPrivateCoreLib>(
    { url: `/api/Transactions/saldo-on-all-periods/${abonentId}`, method: 'GET', signal },
    options
  );
};

export const getGetApiTransactionsSaldoOnAllPeriodsAbonentIdQueryKey = (abonentId: number) => {
  return [`/api/Transactions/saldo-on-all-periods/${abonentId}`] as const;
};

export const getGetApiTransactionsSaldoOnAllPeriodsAbonentIdQueryOptions = <
  TData = Awaited<ReturnType<typeof getApiTransactionsSaldoOnAllPeriodsAbonentId>>,
  TError = ErrorType<unknown>
>(
  abonentId: number,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getApiTransactionsSaldoOnAllPeriodsAbonentId>>, TError, TData>
    >;
    request?: SecondParameter<typeof axiosForReactQueryInstance>;
  }
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetApiTransactionsSaldoOnAllPeriodsAbonentIdQueryKey(abonentId);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getApiTransactionsSaldoOnAllPeriodsAbonentId>>> = ({
    signal
  }) => getApiTransactionsSaldoOnAllPeriodsAbonentId(abonentId, requestOptions, signal);

  return { queryKey, queryFn, enabled: !!abonentId, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getApiTransactionsSaldoOnAllPeriodsAbonentId>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetApiTransactionsSaldoOnAllPeriodsAbonentIdQueryResult = NonNullable<
  Awaited<ReturnType<typeof getApiTransactionsSaldoOnAllPeriodsAbonentId>>
>;
export type GetApiTransactionsSaldoOnAllPeriodsAbonentIdQueryError = ErrorType<unknown>;

export function useGetApiTransactionsSaldoOnAllPeriodsAbonentId<
  TData = Awaited<ReturnType<typeof getApiTransactionsSaldoOnAllPeriodsAbonentId>>,
  TError = ErrorType<unknown>
>(
  abonentId: number,
  options: {
    query: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getApiTransactionsSaldoOnAllPeriodsAbonentId>>, TError, TData>
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiTransactionsSaldoOnAllPeriodsAbonentId>>,
          TError,
          Awaited<ReturnType<typeof getApiTransactionsSaldoOnAllPeriodsAbonentId>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof axiosForReactQueryInstance>;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetApiTransactionsSaldoOnAllPeriodsAbonentId<
  TData = Awaited<ReturnType<typeof getApiTransactionsSaldoOnAllPeriodsAbonentId>>,
  TError = ErrorType<unknown>
>(
  abonentId: number,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getApiTransactionsSaldoOnAllPeriodsAbonentId>>, TError, TData>
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiTransactionsSaldoOnAllPeriodsAbonentId>>,
          TError,
          Awaited<ReturnType<typeof getApiTransactionsSaldoOnAllPeriodsAbonentId>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof axiosForReactQueryInstance>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetApiTransactionsSaldoOnAllPeriodsAbonentId<
  TData = Awaited<ReturnType<typeof getApiTransactionsSaldoOnAllPeriodsAbonentId>>,
  TError = ErrorType<unknown>
>(
  abonentId: number,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getApiTransactionsSaldoOnAllPeriodsAbonentId>>, TError, TData>
    >;
    request?: SecondParameter<typeof axiosForReactQueryInstance>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary Получить сальдо по абоненту за все периоды
 */

export function useGetApiTransactionsSaldoOnAllPeriodsAbonentId<
  TData = Awaited<ReturnType<typeof getApiTransactionsSaldoOnAllPeriodsAbonentId>>,
  TError = ErrorType<unknown>
>(
  abonentId: number,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getApiTransactionsSaldoOnAllPeriodsAbonentId>>, TError, TData>
    >;
    request?: SecondParameter<typeof axiosForReactQueryInstance>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetApiTransactionsSaldoOnAllPeriodsAbonentIdQueryOptions(abonentId, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * @summary Оборотно-сальдовая ведомость по всем абонентам и услугам ОСИ за период
 */
export const getApiTransactionsOsvOsiId = (
  osiId: number,
  params: GetApiTransactionsOsvOsiIdParams,
  options?: SecondParameter<typeof axiosForReactQueryInstance>,
  signal?: AbortSignal
) => {
  return axiosForReactQueryInstance<ApiResponseReportsOSVOSICoreTypes>(
    { url: `/api/Transactions/osv/${osiId}`, method: 'GET', params, signal },
    options
  );
};

export const getGetApiTransactionsOsvOsiIdQueryKey = (osiId: number, params: GetApiTransactionsOsvOsiIdParams) => {
  return [`/api/Transactions/osv/${osiId}`, ...(params ? [params] : [])] as const;
};

export const getGetApiTransactionsOsvOsiIdQueryOptions = <
  TData = Awaited<ReturnType<typeof getApiTransactionsOsvOsiId>>,
  TError = ErrorType<unknown>
>(
  osiId: number,
  params: GetApiTransactionsOsvOsiIdParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiTransactionsOsvOsiId>>, TError, TData>>;
    request?: SecondParameter<typeof axiosForReactQueryInstance>;
  }
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetApiTransactionsOsvOsiIdQueryKey(osiId, params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getApiTransactionsOsvOsiId>>> = ({ signal }) =>
    getApiTransactionsOsvOsiId(osiId, params, requestOptions, signal);

  return { queryKey, queryFn, enabled: !!osiId, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getApiTransactionsOsvOsiId>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetApiTransactionsOsvOsiIdQueryResult = NonNullable<Awaited<ReturnType<typeof getApiTransactionsOsvOsiId>>>;
export type GetApiTransactionsOsvOsiIdQueryError = ErrorType<unknown>;

export function useGetApiTransactionsOsvOsiId<
  TData = Awaited<ReturnType<typeof getApiTransactionsOsvOsiId>>,
  TError = ErrorType<unknown>
>(
  osiId: number,
  params: GetApiTransactionsOsvOsiIdParams,
  options: {
    query: Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiTransactionsOsvOsiId>>, TError, TData>> &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiTransactionsOsvOsiId>>,
          TError,
          Awaited<ReturnType<typeof getApiTransactionsOsvOsiId>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof axiosForReactQueryInstance>;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetApiTransactionsOsvOsiId<
  TData = Awaited<ReturnType<typeof getApiTransactionsOsvOsiId>>,
  TError = ErrorType<unknown>
>(
  osiId: number,
  params: GetApiTransactionsOsvOsiIdParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiTransactionsOsvOsiId>>, TError, TData>> &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiTransactionsOsvOsiId>>,
          TError,
          Awaited<ReturnType<typeof getApiTransactionsOsvOsiId>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof axiosForReactQueryInstance>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetApiTransactionsOsvOsiId<
  TData = Awaited<ReturnType<typeof getApiTransactionsOsvOsiId>>,
  TError = ErrorType<unknown>
>(
  osiId: number,
  params: GetApiTransactionsOsvOsiIdParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiTransactionsOsvOsiId>>, TError, TData>>;
    request?: SecondParameter<typeof axiosForReactQueryInstance>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary Оборотно-сальдовая ведомость по всем абонентам и услугам ОСИ за период
 */

export function useGetApiTransactionsOsvOsiId<
  TData = Awaited<ReturnType<typeof getApiTransactionsOsvOsiId>>,
  TError = ErrorType<unknown>
>(
  osiId: number,
  params: GetApiTransactionsOsvOsiIdParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiTransactionsOsvOsiId>>, TError, TData>>;
    request?: SecondParameter<typeof axiosForReactQueryInstance>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetApiTransactionsOsvOsiIdQueryOptions(osiId, params, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * @summary Оборотно-сальдовая ведомость по всем абонентам и услугам ОСИ за период для отчета "Должники"
 */
export const getApiTransactionsOsvForDebtorsOsiId = (
  osiId: number,
  params: GetApiTransactionsOsvForDebtorsOsiIdParams,
  options?: SecondParameter<typeof axiosForReactQueryInstance>,
  signal?: AbortSignal
) => {
  return axiosForReactQueryInstance<ApiResponseReportsOSVOSICoreTypes>(
    { url: `/api/Transactions/osv-for-debtors/${osiId}`, method: 'GET', params, signal },
    options
  );
};

export const getGetApiTransactionsOsvForDebtorsOsiIdQueryKey = (
  osiId: number,
  params: GetApiTransactionsOsvForDebtorsOsiIdParams
) => {
  return [`/api/Transactions/osv-for-debtors/${osiId}`, ...(params ? [params] : [])] as const;
};

export const getGetApiTransactionsOsvForDebtorsOsiIdQueryOptions = <
  TData = Awaited<ReturnType<typeof getApiTransactionsOsvForDebtorsOsiId>>,
  TError = ErrorType<unknown>
>(
  osiId: number,
  params: GetApiTransactionsOsvForDebtorsOsiIdParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiTransactionsOsvForDebtorsOsiId>>, TError, TData>>;
    request?: SecondParameter<typeof axiosForReactQueryInstance>;
  }
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetApiTransactionsOsvForDebtorsOsiIdQueryKey(osiId, params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getApiTransactionsOsvForDebtorsOsiId>>> = ({ signal }) =>
    getApiTransactionsOsvForDebtorsOsiId(osiId, params, requestOptions, signal);

  return { queryKey, queryFn, enabled: !!osiId, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getApiTransactionsOsvForDebtorsOsiId>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetApiTransactionsOsvForDebtorsOsiIdQueryResult = NonNullable<
  Awaited<ReturnType<typeof getApiTransactionsOsvForDebtorsOsiId>>
>;
export type GetApiTransactionsOsvForDebtorsOsiIdQueryError = ErrorType<unknown>;

export function useGetApiTransactionsOsvForDebtorsOsiId<
  TData = Awaited<ReturnType<typeof getApiTransactionsOsvForDebtorsOsiId>>,
  TError = ErrorType<unknown>
>(
  osiId: number,
  params: GetApiTransactionsOsvForDebtorsOsiIdParams,
  options: {
    query: Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiTransactionsOsvForDebtorsOsiId>>, TError, TData>> &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiTransactionsOsvForDebtorsOsiId>>,
          TError,
          Awaited<ReturnType<typeof getApiTransactionsOsvForDebtorsOsiId>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof axiosForReactQueryInstance>;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetApiTransactionsOsvForDebtorsOsiId<
  TData = Awaited<ReturnType<typeof getApiTransactionsOsvForDebtorsOsiId>>,
  TError = ErrorType<unknown>
>(
  osiId: number,
  params: GetApiTransactionsOsvForDebtorsOsiIdParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiTransactionsOsvForDebtorsOsiId>>, TError, TData>> &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiTransactionsOsvForDebtorsOsiId>>,
          TError,
          Awaited<ReturnType<typeof getApiTransactionsOsvForDebtorsOsiId>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof axiosForReactQueryInstance>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetApiTransactionsOsvForDebtorsOsiId<
  TData = Awaited<ReturnType<typeof getApiTransactionsOsvForDebtorsOsiId>>,
  TError = ErrorType<unknown>
>(
  osiId: number,
  params: GetApiTransactionsOsvForDebtorsOsiIdParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiTransactionsOsvForDebtorsOsiId>>, TError, TData>>;
    request?: SecondParameter<typeof axiosForReactQueryInstance>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary Оборотно-сальдовая ведомость по всем абонентам и услугам ОСИ за период для отчета "Должники"
 */

export function useGetApiTransactionsOsvForDebtorsOsiId<
  TData = Awaited<ReturnType<typeof getApiTransactionsOsvForDebtorsOsiId>>,
  TError = ErrorType<unknown>
>(
  osiId: number,
  params: GetApiTransactionsOsvForDebtorsOsiIdParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiTransactionsOsvForDebtorsOsiId>>, TError, TData>>;
    request?: SecondParameter<typeof axiosForReactQueryInstance>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetApiTransactionsOsvForDebtorsOsiIdQueryOptions(osiId, params, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * @summary Оборотно-сальдовая ведомость по всем абонентам и услугам ОСИ за период с 1 по последнее число текущего месяца
 */
export const getApiTransactionsOsvCurrentMonthOsiId = (
  osiId: number,
  options?: SecondParameter<typeof axiosForReactQueryInstance>,
  signal?: AbortSignal
) => {
  return axiosForReactQueryInstance<ApiResponseReportsOSVOSICoreTypes>(
    { url: `/api/Transactions/osv-current-month/${osiId}`, method: 'GET', signal },
    options
  );
};

export const getGetApiTransactionsOsvCurrentMonthOsiIdQueryKey = (osiId: number) => {
  return [`/api/Transactions/osv-current-month/${osiId}`] as const;
};

export const getGetApiTransactionsOsvCurrentMonthOsiIdQueryOptions = <
  TData = Awaited<ReturnType<typeof getApiTransactionsOsvCurrentMonthOsiId>>,
  TError = ErrorType<unknown>
>(
  osiId: number,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiTransactionsOsvCurrentMonthOsiId>>, TError, TData>>;
    request?: SecondParameter<typeof axiosForReactQueryInstance>;
  }
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetApiTransactionsOsvCurrentMonthOsiIdQueryKey(osiId);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getApiTransactionsOsvCurrentMonthOsiId>>> = ({ signal }) =>
    getApiTransactionsOsvCurrentMonthOsiId(osiId, requestOptions, signal);

  return { queryKey, queryFn, enabled: !!osiId, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getApiTransactionsOsvCurrentMonthOsiId>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetApiTransactionsOsvCurrentMonthOsiIdQueryResult = NonNullable<
  Awaited<ReturnType<typeof getApiTransactionsOsvCurrentMonthOsiId>>
>;
export type GetApiTransactionsOsvCurrentMonthOsiIdQueryError = ErrorType<unknown>;

export function useGetApiTransactionsOsvCurrentMonthOsiId<
  TData = Awaited<ReturnType<typeof getApiTransactionsOsvCurrentMonthOsiId>>,
  TError = ErrorType<unknown>
>(
  osiId: number,
  options: {
    query: Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiTransactionsOsvCurrentMonthOsiId>>, TError, TData>> &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiTransactionsOsvCurrentMonthOsiId>>,
          TError,
          Awaited<ReturnType<typeof getApiTransactionsOsvCurrentMonthOsiId>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof axiosForReactQueryInstance>;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetApiTransactionsOsvCurrentMonthOsiId<
  TData = Awaited<ReturnType<typeof getApiTransactionsOsvCurrentMonthOsiId>>,
  TError = ErrorType<unknown>
>(
  osiId: number,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getApiTransactionsOsvCurrentMonthOsiId>>, TError, TData>
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiTransactionsOsvCurrentMonthOsiId>>,
          TError,
          Awaited<ReturnType<typeof getApiTransactionsOsvCurrentMonthOsiId>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof axiosForReactQueryInstance>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetApiTransactionsOsvCurrentMonthOsiId<
  TData = Awaited<ReturnType<typeof getApiTransactionsOsvCurrentMonthOsiId>>,
  TError = ErrorType<unknown>
>(
  osiId: number,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiTransactionsOsvCurrentMonthOsiId>>, TError, TData>>;
    request?: SecondParameter<typeof axiosForReactQueryInstance>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary Оборотно-сальдовая ведомость по всем абонентам и услугам ОСИ за период с 1 по последнее число текущего месяца
 */

export function useGetApiTransactionsOsvCurrentMonthOsiId<
  TData = Awaited<ReturnType<typeof getApiTransactionsOsvCurrentMonthOsiId>>,
  TError = ErrorType<unknown>
>(
  osiId: number,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiTransactionsOsvCurrentMonthOsiId>>, TError, TData>>;
    request?: SecondParameter<typeof axiosForReactQueryInstance>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetApiTransactionsOsvCurrentMonthOsiIdQueryOptions(osiId, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * @summary Платежи по всем абонентам и услугам ОСИ за период
 */
export const getApiTransactionsPaymentsOsiId = (
  osiId: number,
  params: GetApiTransactionsPaymentsOsiIdParams,
  options?: SecondParameter<typeof axiosForReactQueryInstance>,
  signal?: AbortSignal
) => {
  return axiosForReactQueryInstance<ApiResponseList1OSICoreModelsReportsPaymentTransactionPrivateCoreLib>(
    { url: `/api/Transactions/payments/${osiId}`, method: 'GET', params, signal },
    options
  );
};

export const getGetApiTransactionsPaymentsOsiIdQueryKey = (
  osiId: number,
  params: GetApiTransactionsPaymentsOsiIdParams
) => {
  return [`/api/Transactions/payments/${osiId}`, ...(params ? [params] : [])] as const;
};

export const getGetApiTransactionsPaymentsOsiIdQueryOptions = <
  TData = Awaited<ReturnType<typeof getApiTransactionsPaymentsOsiId>>,
  TError = ErrorType<unknown>
>(
  osiId: number,
  params: GetApiTransactionsPaymentsOsiIdParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiTransactionsPaymentsOsiId>>, TError, TData>>;
    request?: SecondParameter<typeof axiosForReactQueryInstance>;
  }
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetApiTransactionsPaymentsOsiIdQueryKey(osiId, params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getApiTransactionsPaymentsOsiId>>> = ({ signal }) =>
    getApiTransactionsPaymentsOsiId(osiId, params, requestOptions, signal);

  return { queryKey, queryFn, enabled: !!osiId, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getApiTransactionsPaymentsOsiId>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetApiTransactionsPaymentsOsiIdQueryResult = NonNullable<
  Awaited<ReturnType<typeof getApiTransactionsPaymentsOsiId>>
>;
export type GetApiTransactionsPaymentsOsiIdQueryError = ErrorType<unknown>;

export function useGetApiTransactionsPaymentsOsiId<
  TData = Awaited<ReturnType<typeof getApiTransactionsPaymentsOsiId>>,
  TError = ErrorType<unknown>
>(
  osiId: number,
  params: GetApiTransactionsPaymentsOsiIdParams,
  options: {
    query: Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiTransactionsPaymentsOsiId>>, TError, TData>> &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiTransactionsPaymentsOsiId>>,
          TError,
          Awaited<ReturnType<typeof getApiTransactionsPaymentsOsiId>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof axiosForReactQueryInstance>;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetApiTransactionsPaymentsOsiId<
  TData = Awaited<ReturnType<typeof getApiTransactionsPaymentsOsiId>>,
  TError = ErrorType<unknown>
>(
  osiId: number,
  params: GetApiTransactionsPaymentsOsiIdParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiTransactionsPaymentsOsiId>>, TError, TData>> &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiTransactionsPaymentsOsiId>>,
          TError,
          Awaited<ReturnType<typeof getApiTransactionsPaymentsOsiId>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof axiosForReactQueryInstance>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetApiTransactionsPaymentsOsiId<
  TData = Awaited<ReturnType<typeof getApiTransactionsPaymentsOsiId>>,
  TError = ErrorType<unknown>
>(
  osiId: number,
  params: GetApiTransactionsPaymentsOsiIdParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiTransactionsPaymentsOsiId>>, TError, TData>>;
    request?: SecondParameter<typeof axiosForReactQueryInstance>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary Платежи по всем абонентам и услугам ОСИ за период
 */

export function useGetApiTransactionsPaymentsOsiId<
  TData = Awaited<ReturnType<typeof getApiTransactionsPaymentsOsiId>>,
  TError = ErrorType<unknown>
>(
  osiId: number,
  params: GetApiTransactionsPaymentsOsiIdParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiTransactionsPaymentsOsiId>>, TError, TData>>;
    request?: SecondParameter<typeof axiosForReactQueryInstance>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetApiTransactionsPaymentsOsiIdQueryOptions(osiId, params, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * @summary Корректировки по всем абонентам и услугам ОСИ за период
 */
export const getApiTransactionsFixesOsiId = (
  osiId: number,
  params: GetApiTransactionsFixesOsiIdParams,
  options?: SecondParameter<typeof axiosForReactQueryInstance>,
  signal?: AbortSignal
) => {
  return axiosForReactQueryInstance<ApiResponseList1OSICoreModelsReportsFixTransactionPrivateCoreLib>(
    { url: `/api/Transactions/fixes/${osiId}`, method: 'GET', params, signal },
    options
  );
};

export const getGetApiTransactionsFixesOsiIdQueryKey = (osiId: number, params: GetApiTransactionsFixesOsiIdParams) => {
  return [`/api/Transactions/fixes/${osiId}`, ...(params ? [params] : [])] as const;
};

export const getGetApiTransactionsFixesOsiIdQueryOptions = <
  TData = Awaited<ReturnType<typeof getApiTransactionsFixesOsiId>>,
  TError = ErrorType<unknown>
>(
  osiId: number,
  params: GetApiTransactionsFixesOsiIdParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiTransactionsFixesOsiId>>, TError, TData>>;
    request?: SecondParameter<typeof axiosForReactQueryInstance>;
  }
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetApiTransactionsFixesOsiIdQueryKey(osiId, params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getApiTransactionsFixesOsiId>>> = ({ signal }) =>
    getApiTransactionsFixesOsiId(osiId, params, requestOptions, signal);

  return { queryKey, queryFn, enabled: !!osiId, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getApiTransactionsFixesOsiId>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetApiTransactionsFixesOsiIdQueryResult = NonNullable<
  Awaited<ReturnType<typeof getApiTransactionsFixesOsiId>>
>;
export type GetApiTransactionsFixesOsiIdQueryError = ErrorType<unknown>;

export function useGetApiTransactionsFixesOsiId<
  TData = Awaited<ReturnType<typeof getApiTransactionsFixesOsiId>>,
  TError = ErrorType<unknown>
>(
  osiId: number,
  params: GetApiTransactionsFixesOsiIdParams,
  options: {
    query: Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiTransactionsFixesOsiId>>, TError, TData>> &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiTransactionsFixesOsiId>>,
          TError,
          Awaited<ReturnType<typeof getApiTransactionsFixesOsiId>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof axiosForReactQueryInstance>;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetApiTransactionsFixesOsiId<
  TData = Awaited<ReturnType<typeof getApiTransactionsFixesOsiId>>,
  TError = ErrorType<unknown>
>(
  osiId: number,
  params: GetApiTransactionsFixesOsiIdParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiTransactionsFixesOsiId>>, TError, TData>> &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiTransactionsFixesOsiId>>,
          TError,
          Awaited<ReturnType<typeof getApiTransactionsFixesOsiId>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof axiosForReactQueryInstance>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetApiTransactionsFixesOsiId<
  TData = Awaited<ReturnType<typeof getApiTransactionsFixesOsiId>>,
  TError = ErrorType<unknown>
>(
  osiId: number,
  params: GetApiTransactionsFixesOsiIdParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiTransactionsFixesOsiId>>, TError, TData>>;
    request?: SecondParameter<typeof axiosForReactQueryInstance>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary Корректировки по всем абонентам и услугам ОСИ за период
 */

export function useGetApiTransactionsFixesOsiId<
  TData = Awaited<ReturnType<typeof getApiTransactionsFixesOsiId>>,
  TError = ErrorType<unknown>
>(
  osiId: number,
  params: GetApiTransactionsFixesOsiIdParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiTransactionsFixesOsiId>>, TError, TData>>;
    request?: SecondParameter<typeof axiosForReactQueryInstance>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetApiTransactionsFixesOsiIdQueryOptions(osiId, params, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * @summary Создать платеж
 */
export const postApiTransactionsPayment = (
  requestsCreatePaymentRequest: BodyType<RequestsCreatePaymentRequest>,
  params: PostApiTransactionsPaymentParams,
  options?: SecondParameter<typeof axiosForReactQueryInstance>,
  signal?: AbortSignal
) => {
  return axiosForReactQueryInstance<ApiResponseResponsesCreatePaymentResponseOSICoreTypes>(
    {
      url: `/api/Transactions/payment`,
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      data: requestsCreatePaymentRequest,
      params,
      signal
    },
    options
  );
};

export const getPostApiTransactionsPaymentMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postApiTransactionsPayment>>,
    TError,
    { data: BodyType<RequestsCreatePaymentRequest>; params: PostApiTransactionsPaymentParams },
    TContext
  >;
  request?: SecondParameter<typeof axiosForReactQueryInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof postApiTransactionsPayment>>,
  TError,
  { data: BodyType<RequestsCreatePaymentRequest>; params: PostApiTransactionsPaymentParams },
  TContext
> => {
  const mutationKey = ['postApiTransactionsPayment'];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof postApiTransactionsPayment>>,
    { data: BodyType<RequestsCreatePaymentRequest>; params: PostApiTransactionsPaymentParams }
  > = (props) => {
    const { data, params } = props ?? {};

    return postApiTransactionsPayment(data, params, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type PostApiTransactionsPaymentMutationResult = NonNullable<
  Awaited<ReturnType<typeof postApiTransactionsPayment>>
>;
export type PostApiTransactionsPaymentMutationBody = BodyType<RequestsCreatePaymentRequest>;
export type PostApiTransactionsPaymentMutationError = ErrorType<unknown>;

/**
 * @summary Создать платеж
 */
export const usePostApiTransactionsPayment = <TError = ErrorType<unknown>, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof postApiTransactionsPayment>>,
      TError,
      { data: BodyType<RequestsCreatePaymentRequest>; params: PostApiTransactionsPaymentParams },
      TContext
    >;
    request?: SecondParameter<typeof axiosForReactQueryInstance>;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof postApiTransactionsPayment>>,
  TError,
  { data: BodyType<RequestsCreatePaymentRequest>; params: PostApiTransactionsPaymentParams },
  TContext
> => {
  const mutationOptions = getPostApiTransactionsPaymentMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
/**
 * @summary Создать платеж
 */
export const postApiTransactionsPaymentInternal = (
  requestsCreatePaymentInternalRequest: BodyType<RequestsCreatePaymentInternalRequest>,
  params: PostApiTransactionsPaymentInternalParams,
  options?: SecondParameter<typeof axiosForReactQueryInstance>,
  signal?: AbortSignal
) => {
  return axiosForReactQueryInstance<ApiResponseInt32SystemPrivateCoreLib>(
    {
      url: `/api/Transactions/payment/internal`,
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      data: requestsCreatePaymentInternalRequest,
      params,
      signal
    },
    options
  );
};

export const getPostApiTransactionsPaymentInternalMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postApiTransactionsPaymentInternal>>,
    TError,
    { data: BodyType<RequestsCreatePaymentInternalRequest>; params: PostApiTransactionsPaymentInternalParams },
    TContext
  >;
  request?: SecondParameter<typeof axiosForReactQueryInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof postApiTransactionsPaymentInternal>>,
  TError,
  { data: BodyType<RequestsCreatePaymentInternalRequest>; params: PostApiTransactionsPaymentInternalParams },
  TContext
> => {
  const mutationKey = ['postApiTransactionsPaymentInternal'];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof postApiTransactionsPaymentInternal>>,
    { data: BodyType<RequestsCreatePaymentInternalRequest>; params: PostApiTransactionsPaymentInternalParams }
  > = (props) => {
    const { data, params } = props ?? {};

    return postApiTransactionsPaymentInternal(data, params, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type PostApiTransactionsPaymentInternalMutationResult = NonNullable<
  Awaited<ReturnType<typeof postApiTransactionsPaymentInternal>>
>;
export type PostApiTransactionsPaymentInternalMutationBody = BodyType<RequestsCreatePaymentInternalRequest>;
export type PostApiTransactionsPaymentInternalMutationError = ErrorType<unknown>;

/**
 * @summary Создать платеж
 */
export const usePostApiTransactionsPaymentInternal = <TError = ErrorType<unknown>, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof postApiTransactionsPaymentInternal>>,
      TError,
      { data: BodyType<RequestsCreatePaymentInternalRequest>; params: PostApiTransactionsPaymentInternalParams },
      TContext
    >;
    request?: SecondParameter<typeof axiosForReactQueryInstance>;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof postApiTransactionsPaymentInternal>>,
  TError,
  { data: BodyType<RequestsCreatePaymentInternalRequest>; params: PostApiTransactionsPaymentInternalParams },
  TContext
> => {
  const mutationOptions = getPostApiTransactionsPaymentInternalMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
/**
 * @summary Создать корректировку
 */
export const postApiTransactionsFixInternal = (
  requestsCreateFixRequest: BodyType<RequestsCreateFixRequest>,
  params: PostApiTransactionsFixInternalParams,
  options?: SecondParameter<typeof axiosForReactQueryInstance>,
  signal?: AbortSignal
) => {
  return axiosForReactQueryInstance<ApiResponseInt32SystemPrivateCoreLib>(
    {
      url: `/api/Transactions/fix/internal`,
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      data: requestsCreateFixRequest,
      params,
      signal
    },
    options
  );
};

export const getPostApiTransactionsFixInternalMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postApiTransactionsFixInternal>>,
    TError,
    { data: BodyType<RequestsCreateFixRequest>; params: PostApiTransactionsFixInternalParams },
    TContext
  >;
  request?: SecondParameter<typeof axiosForReactQueryInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof postApiTransactionsFixInternal>>,
  TError,
  { data: BodyType<RequestsCreateFixRequest>; params: PostApiTransactionsFixInternalParams },
  TContext
> => {
  const mutationKey = ['postApiTransactionsFixInternal'];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof postApiTransactionsFixInternal>>,
    { data: BodyType<RequestsCreateFixRequest>; params: PostApiTransactionsFixInternalParams }
  > = (props) => {
    const { data, params } = props ?? {};

    return postApiTransactionsFixInternal(data, params, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type PostApiTransactionsFixInternalMutationResult = NonNullable<
  Awaited<ReturnType<typeof postApiTransactionsFixInternal>>
>;
export type PostApiTransactionsFixInternalMutationBody = BodyType<RequestsCreateFixRequest>;
export type PostApiTransactionsFixInternalMutationError = ErrorType<unknown>;

/**
 * @summary Создать корректировку
 */
export const usePostApiTransactionsFixInternal = <TError = ErrorType<unknown>, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof postApiTransactionsFixInternal>>,
      TError,
      { data: BodyType<RequestsCreateFixRequest>; params: PostApiTransactionsFixInternalParams },
      TContext
    >;
    request?: SecondParameter<typeof axiosForReactQueryInstance>;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof postApiTransactionsFixInternal>>,
  TError,
  { data: BodyType<RequestsCreateFixRequest>; params: PostApiTransactionsFixInternalParams },
  TContext
> => {
  const mutationOptions = getPostApiTransactionsFixInternalMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
/**
 * @summary Начислить пеню
 */
export const postApiTransactionsFine = (
  params: PostApiTransactionsFineParams,
  options?: SecondParameter<typeof axiosForReactQueryInstance>,
  signal?: AbortSignal
) => {
  return axiosForReactQueryInstance<ApiResponse>(
    { url: `/api/Transactions/fine`, method: 'POST', params, signal },
    options
  );
};

export const getPostApiTransactionsFineMutationOptions = <TError = ErrorType<unknown>, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postApiTransactionsFine>>,
    TError,
    { params: PostApiTransactionsFineParams },
    TContext
  >;
  request?: SecondParameter<typeof axiosForReactQueryInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof postApiTransactionsFine>>,
  TError,
  { params: PostApiTransactionsFineParams },
  TContext
> => {
  const mutationKey = ['postApiTransactionsFine'];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof postApiTransactionsFine>>,
    { params: PostApiTransactionsFineParams }
  > = (props) => {
    const { params } = props ?? {};

    return postApiTransactionsFine(params, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type PostApiTransactionsFineMutationResult = NonNullable<Awaited<ReturnType<typeof postApiTransactionsFine>>>;

export type PostApiTransactionsFineMutationError = ErrorType<unknown>;

/**
 * @summary Начислить пеню
 */
export const usePostApiTransactionsFine = <TError = ErrorType<unknown>, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof postApiTransactionsFine>>,
      TError,
      { params: PostApiTransactionsFineParams },
      TContext
    >;
    request?: SecondParameter<typeof axiosForReactQueryInstance>;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof postApiTransactionsFine>>,
  TError,
  { params: PostApiTransactionsFineParams },
  TContext
> => {
  const mutationOptions = getPostApiTransactionsFineMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
/**
 * @summary Отчет по начислениям абонента за период
 */
export const getApiTransactionsAccuralsByAbonentAndServicesAbonentId = (
  abonentId: number,
  params: GetApiTransactionsAccuralsByAbonentAndServicesAbonentIdParams,
  options?: SecondParameter<typeof axiosForReactQueryInstance>,
  signal?: AbortSignal
) => {
  return axiosForReactQueryInstance<ApiResponseList1OSICoreModelsReportsAccuralsByAbonentAndServicesGroupPrivateCoreLib>(
    { url: `/api/Transactions/accurals-by-abonent-and-services/${abonentId}`, method: 'GET', params, signal },
    options
  );
};

export const getGetApiTransactionsAccuralsByAbonentAndServicesAbonentIdQueryKey = (
  abonentId: number,
  params: GetApiTransactionsAccuralsByAbonentAndServicesAbonentIdParams
) => {
  return [`/api/Transactions/accurals-by-abonent-and-services/${abonentId}`, ...(params ? [params] : [])] as const;
};

export const getGetApiTransactionsAccuralsByAbonentAndServicesAbonentIdQueryOptions = <
  TData = Awaited<ReturnType<typeof getApiTransactionsAccuralsByAbonentAndServicesAbonentId>>,
  TError = ErrorType<unknown>
>(
  abonentId: number,
  params: GetApiTransactionsAccuralsByAbonentAndServicesAbonentIdParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getApiTransactionsAccuralsByAbonentAndServicesAbonentId>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof axiosForReactQueryInstance>;
  }
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetApiTransactionsAccuralsByAbonentAndServicesAbonentIdQueryKey(abonentId, params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getApiTransactionsAccuralsByAbonentAndServicesAbonentId>>> = ({
    signal
  }) => getApiTransactionsAccuralsByAbonentAndServicesAbonentId(abonentId, params, requestOptions, signal);

  return { queryKey, queryFn, enabled: !!abonentId, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getApiTransactionsAccuralsByAbonentAndServicesAbonentId>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetApiTransactionsAccuralsByAbonentAndServicesAbonentIdQueryResult = NonNullable<
  Awaited<ReturnType<typeof getApiTransactionsAccuralsByAbonentAndServicesAbonentId>>
>;
export type GetApiTransactionsAccuralsByAbonentAndServicesAbonentIdQueryError = ErrorType<unknown>;

export function useGetApiTransactionsAccuralsByAbonentAndServicesAbonentId<
  TData = Awaited<ReturnType<typeof getApiTransactionsAccuralsByAbonentAndServicesAbonentId>>,
  TError = ErrorType<unknown>
>(
  abonentId: number,
  params: GetApiTransactionsAccuralsByAbonentAndServicesAbonentIdParams,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getApiTransactionsAccuralsByAbonentAndServicesAbonentId>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiTransactionsAccuralsByAbonentAndServicesAbonentId>>,
          TError,
          Awaited<ReturnType<typeof getApiTransactionsAccuralsByAbonentAndServicesAbonentId>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof axiosForReactQueryInstance>;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetApiTransactionsAccuralsByAbonentAndServicesAbonentId<
  TData = Awaited<ReturnType<typeof getApiTransactionsAccuralsByAbonentAndServicesAbonentId>>,
  TError = ErrorType<unknown>
>(
  abonentId: number,
  params: GetApiTransactionsAccuralsByAbonentAndServicesAbonentIdParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getApiTransactionsAccuralsByAbonentAndServicesAbonentId>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiTransactionsAccuralsByAbonentAndServicesAbonentId>>,
          TError,
          Awaited<ReturnType<typeof getApiTransactionsAccuralsByAbonentAndServicesAbonentId>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof axiosForReactQueryInstance>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetApiTransactionsAccuralsByAbonentAndServicesAbonentId<
  TData = Awaited<ReturnType<typeof getApiTransactionsAccuralsByAbonentAndServicesAbonentId>>,
  TError = ErrorType<unknown>
>(
  abonentId: number,
  params: GetApiTransactionsAccuralsByAbonentAndServicesAbonentIdParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getApiTransactionsAccuralsByAbonentAndServicesAbonentId>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof axiosForReactQueryInstance>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary Отчет по начислениям абонента за период
 */

export function useGetApiTransactionsAccuralsByAbonentAndServicesAbonentId<
  TData = Awaited<ReturnType<typeof getApiTransactionsAccuralsByAbonentAndServicesAbonentId>>,
  TError = ErrorType<unknown>
>(
  abonentId: number,
  params: GetApiTransactionsAccuralsByAbonentAndServicesAbonentIdParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getApiTransactionsAccuralsByAbonentAndServicesAbonentId>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof axiosForReactQueryInstance>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetApiTransactionsAccuralsByAbonentAndServicesAbonentIdQueryOptions(
    abonentId,
    params,
    options
  );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}
